/// <amd-module name="Artifacts/Feed/services/ProblemPackageListService" />
import { ProblemPackageItem } from "Artifacts/Feed/types/ProblemPackageItem";
import * as Constants from "Artifacts/Root/Constants";
import { loadNonNullData } from "Artifacts/Root/helpers/DataProviderHelpers";
import { IFeed } from "Artifacts/Root/types";
import { ProblemPackage } from "Artifacts/Root/types/PackagingShared";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IProblemPackageListService extends IVssService {
  getPackageList(context: IVssPageContext, feed: IFeed): Promise<ProblemPackageItem[]>;
}

export class ProblemPackageListService extends VssService implements IProblemPackageListService {
  async getPackageList(context: IVssPageContext, feed: IFeed): Promise<ProblemPackageItem[]> {
    const properties = {
      feedId: feed && feed.id,
      projectId: feed && feed.project ? feed.project.id : null,
    };

    const data = await loadNonNullData<ProblemPackage[]>(
      context,
      "ms.azure-artifacts.problem-packages-data-provider",
      properties,
      true,
      Constants.CommonConstants.PackagingServiceInstanceId,
    );

    const mappedData = data
      ? data.map<ProblemPackageItem>((item) => ({
          protocolId: item.protocol,
          packageName: item.packageName,
          packageVersion: item.packageVersion,
          sourceName: item.upstreamSource.name,
          status: item.reasons.map((reason) => reason.code).join(", "),
          description: item.reasons
            .map((reason) => `[${reason.code}] ${reason.message}`)
            .join(", "),
          failedDate: item.timestamp,
        }))
      : [];

    return mappedData;
  }
}

Services.add("IProblemPackageListService", { serviceFactory: ProblemPackageListService });
